import React from "react";
import PropTypes from "prop-types";
import { EditableText } from "../../EditableText/EditableText";
import { TableCell } from "../../Table";
import "./SheetCell.scss";

export class SheetCell extends React.Component {
  static propTypes = {
    onRecordChange: PropTypes.func,
    row: PropTypes.object,
    index: PropTypes.number,
    column: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string,
      editable: PropTypes.bool,
      required: PropTypes.bool,
    }),
  };

  renderText = () => {
    const { column, row } = this.props;

    return <div data-testid="SheetCell__Text">{row[column.id]}</div>;
  };

  render() {
    const { column, index, onRecordChange, row } = this.props;

    return (
      <TableCell className="SheetCell">
        {column.editable ? (
          <EditableText
            onSave={onRecordChange}
            id={[index, column.id]}
            defaultInputValue={row[column.id]}
            type={column.type}
            required={column.required}
            renderText={this.renderText}
          />
        ) : (
          this.renderText()
        )}
      </TableCell>
    );
  }
}

export default SheetCell;
